<template>
  <div style="">
    <el-row>
      <el-col :lg="24">
        <el-card class="box-card" >
          <div slot="header" class="clearfix">
            <span>{{ personnel.person_info.fullname }}</span>
            <span style="margin-left: 20px">
              <el-select v-model="filterstatus" size="small" placeholder="Filter by" style="width: 100px" @change="getAll">
                <el-option
                  v-for="item in data_status"
                  :key="item.id"
                  :label="item.label"
                  :value="item.id"/>
              </el-select>
            </span>
            <!--span v-if="roleACC" style="float: right;"><el-button type="success" size="small" @click="show_computation"><i class="el-icon-document" /> Recompute Individual Tax</el-button></span-->
            <span style="float: right; padding-right: 20%" type="text">Total Deduction(s) : {{ Number((total)?total:0).toLocaleString(undefined, {minimumFractionDigits: 2}) }}</span>
          </div>
          <el-table
            v-loading="loading"
            ref="multipleTable"
            :data="empDeduction"
            :cell-class-name="setclass"
            :header-cell-class-name="setheadclass"
            :element-loading-text="loadingText"
            height="400"
            size="small"
            style="width: 100%">
            <el-table-column
              fixed
              width="50">
              <template slot-scope="scope">
                <el-checkbox :key="scope.row.id" :checked="scope.row.active===1" @change="changeStatus(scope.row.id, $event)" />
              </template>
            </el-table-column>
            <el-table-column prop="ref_deduction.code" label="Code" width="150"/>
            <el-table-column prop="ref_deduction.desc" label="Deduction" width="350"/>
            <el-table-column label="Start Date" >
              <template slot-scope="scope">
                {{ format_date(scope.row.deduction_details.startdate) }}
              </template>
            </el-table-column>
            <el-table-column label="End Date" >
              <template slot-scope="scope">
                {{ format_date(scope.row.deduction_details.enddate) }}
              </template>
            </el-table-column>
            <el-table-column prop="deduction_details.amount" label="Amount" >
              <template slot-scope="scope">
                {{ Number(scope.row.deduction_details.amount).toLocaleString(undefined, {minimumFractionDigits: 2}) }}
              </template>
            </el-table-column>
            <el-table-column label="update" >
              <template slot-scope="scope">
                <el-button v-if="allow_update(scope.row.ref_deduction.incharge.acronym, scope.row.ref_deduction.id)" type="warning" size="small" @click="update(scope.row)" ><i class="el-icon-edit"/></el-button>
              </template>
            </el-table-column>
          </el-table>
          <div style="text-align: center;">
            <el-pagination :page-size="meta.per_page" :pager-count="11" :total="meta.total" :current-page.sync="meta.page" layout="total, prev, pager, next" @current-change="getAll"/>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { EmpDeduction } from '@/api/payroll/empdeduction'
import SelectDeduction from '@/views/layout/components/SelectDeduction'
import { Ledger } from '@/api/payroll/ledger'
import { NotifySuccess } from '@/helper/Helper'
import moment from 'moment'
export default {
  name: 'ListDeduction',
  components: {
    SelectDeduction
  },
  props: {
    personnel: {
      default: null,
      type: Object,
      required: true
    }
  },
  data() {
    return {
      data_status: [
        {
          'id': 1,
          'label': 'Active'
        },
        {
          'id': 0,
          'label': 'In-Active'
        }
      ],
      filterstatus: 1,
      form: {},
      roleACC: false,
      meta: {
        page: 1
      },
      loading: false,
      loadingText: null,
      deduction: {},
      total: 0,
      addDeduction: false,
      empDeduction: [],
      dialogFormVisible: false,
      enddate_option: {
        disabledDate: (date) => {
          if (this.form.startdate !== null) {
            return date.getTime() < this.form.startdate
          }
        }
      }
    }
  },
  created() {
    this.getAll()
    this.checkRole()
  },
  methods: {
    checkRole() {
      var self = this
      this.$store.getters.user.currentUser.roles.forEach(function(value, key) {
        if (value.name === 'payroll_accounting') {
          self.roleACC = true
        }
      })
    },
    show_computation() {
      this.loading = true
      this.loadingText = 'Updating Withholding tax! Please wait...'
      // this.computation = true
      this.form.id = this.personnel.id
      this.form.personnel_id = this.personnel.id
      this.form.year = this.getFormattedYear(new Date())
      this.form.benefitCat = 'others'
      this.form.amount = this.total
      Ledger(this.form, 'get', 'annual-tax').then(res => {
        // this.tableData = res.data.computed_tax.collection
        this.new_deduction = res.data.computed_tax.new_deduction
        this.detail_id = res.data.computed_tax.detail_id
        // this.form.id = null
        this.save()
      }).catch()
    },
    save() {
      EmpDeduction({ 'detail_id': this.detail_id, 'amount': this.new_deduction }, 'post', 'update-tax').then(res => {
        if (res.data.message === 'success') {
          var mess = 'Withholding Tax of (' + this.personnel.person_info.fullname + ') is Updated Successfully!'
          NotifySuccess(mess)
          this.loading = false
          this.getAll()
        }
      }).catch()
    },
    getFormattedYear(date) {
      return this.$moment(date).format('YYYY')
    },
    getAll() {
      this.loading = true
      EmpDeduction({ filterstatus: this.filterstatus, personnel_id: this.personnel.id, page: this.meta.page }, 'get', '').then(res => {
        this.empDeduction = res.data.empdeduction
        this.meta = res.data.meta
        this.getTotal()
        this.loading = false
      }).catch(error => {
        console.log(error)
      })
    },
    getTotal() {
      EmpDeduction({ id: this.personnel.id }, 'get', 'total').then(res => {
        this.total = res.data.totalDeduction.total
        this.loading = false
        this.$emit('active', this.total)
      }).catch(error => {
        console.log(error)
      })
    },
    allow_update(incharge, id) {
      if (id === 27) {
        return false
      }
      if (this.$store.getters.user.currentUser.personnel.department.acronym === incharge || (this.$store.getters.user.currentUser.allowed_views).includes('PAYROLLADMIN')) {
        return true
      }
      return false
    },
    changeStatus(id, event) {
      EmpDeduction({ id: id, status: event }, 'post', 'set-active').then(res => {
        this.getTotal()
        this.updateParent()
        if (event) {
          this.$message({ message: 'Activated.', type: 'success' })
        } else {
          this.$message({ message: 'Deactivated.', type: 'warning' })
        }
      }).catch(error => {
        console.log(error)
      })
    },
    update(data) {
      this.$emit('update', data)
    },
    updateParent() {
      this.$emit('key')
    },
    getFormattedDate(date) {
      if (date) return this.$moment(date).format('YYYY-MM-DD')
      return null
    },
    format_date(value) {
      if (value) return moment(String(value)).format('MM/DD/YYYY')
      return '--'
    },
    setclass(row) {
      if (row.columnIndex === 5) {
        return 'cell_' + row.columnIndex
      }
    },
    setheadclass(row) {
      if (row.columnIndex === 5) {
        return 'header_' + row.columnIndex
      }
    }
  }
}
</script>

<style lang="scss">
  .el-alert--info {
    background-color: #e1ffd0 !important;
  }
  .cell_5 {
    text-align: right;
  }
  .header_5 {
    text-align: center !important;
  }
</style>
